var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "700" } },
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.title) + " "),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  attrs: { small: "", white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            _vm._l(_vm.files, function (file) {
              return _c(
                "w-list-item",
                { key: file.ID },
                [
                  file.File
                    ? _c("w-list-item-text", [_vm._v(_vm._s(file.File.Name))])
                    : _vm._e(),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("open-document"),
                              expression: "$ct('open-document')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.open(file)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "eye" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("download"),
                              expression: "$ct('download')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.download(file)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "download" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("send-email"),
                              expression: "$ct('send-email')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.send(file)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "envelope" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }